'use strict';
  
angular.module('sellersService')
.factory('AgentService', ['appInfo', '$log', '$http', '$q', '$rootScope', 'CacheFactory', 
    function (appInfo, $log, $http, $q, $rootScope, CacheFactory) {
        var service = {}
            , code    = $rootScope.currentUser.authdata
            , expires =  moment().add(15, 'm').unix();

        var agencyCache;

        if (!CacheFactory.get('agentCache')) {
          agentCache = CacheFactory('agentCache', {
                          maxAge: 15 * 60 * 1000,
                          deleteOnExpire: 'aggressive'
                        });
        }

        service.agencyContacts = function(identifier) {
            var dfd = $q.defer();
            
            $http({
                    url: appInfo.endpoint+'agency/agent.json', 
                    method: "GET",
                    params: {identifier: identifier, api_key: appInfo.key},
                    cache: CacheFactory.get('agentCache')
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;
        }


        service.getAgent = function(agentId) {
            var dfd = $q.defer();
            
            $http({
                    url: appInfo.endpoint+'agency/agent.json', 
                    method: "GET",
                    params: {contact: agentId, api_key: appInfo.key},
                    cache: CacheFactory.get('agentCache')
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;

        };

        service.getAgentListings = function(agentId) {
            var dfd = $q.defer();
            
            $http({
                    url: appInfo.endpoint+'listing/agentstats.json', 
                    method: "GET",
                    params: {id: agentId, api_key: appInfo.pkey},
                    cache: CacheFactory.get('agentCache')
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;

        };
        
        return service;

}]);